<template src="@/templates/serviceDelivery/sdPendingDetails.html"></template>

<script>
import ServiceDeliveryFormModel from "@/models/serviceDeliveryFormModel";
import UploadForm from "@/components/file/UploadForm";
import { mapActions } from "vuex";

export default {
  name: "SDPendingDetails",
  props: ["SDFModel"],
  components: {
    UploadForm,
  },
  data() {
    return {
      serviceDeliveryFormModel: new ServiceDeliveryFormModel(),
      viewUploadFormComp: false,
    };
  },
  created() {
    this.fetchSDPDetails();
  },
  mounted() {
    Event.$on("goBackFromBookings", () => {
      this.goBack();
    });

    Event.$on("backToUploadDetailsComp", () => {
      let thisComponent = this;
      setTimeout(function () {
        thisComponent.viewUploadFormComp = false;
        thisComponent.goBack();
      }, 50);
    });
  },
  methods: {
    ...mapActions([
      "updateJobMatchingConditions",
      "updateJobRefNum",
      "updateImageFor",
      "updateIcon",
      "updateCameraState",
      "updateBackButton",
    ]),
    fetchSDPDetails() {
      this.updateBackButton(true);
      this.updateImageFor("jobSlips");
      this.updateIcon(["camera", "sign-in-alt", "sign-out-alt"]);
      this.updateJobRefNum(this.SDFModel.ref_num);

      this.serviceDeliveryFormModel.dbData =
        this.SDFModel.attributes.dbData.data;
      this.serviceDeliveryFormModel.ref_num = this.SDFModel.ref_num;

      this.serviceDeliveryFormModel
        .checkSDPDetails()
        .then((JARModelRes) => {
          let res = JARModelRes.response.data;
          let found = res.found;

          if (found) {
            this.foundMessage();
          }

          this.updateJobMatchingConditions([
            this.serviceDeliveryFormModel.dbData,
            false,
            true,
          ]);
        })
        .catch((PCError) => {
          let errorMessage = "Network error. " + PCError;
          this.fetchError(errorMessage);
          console.error(PCError);
        });
    },
    foundMessage() {
      this.$vs.notify({
        title: "Found!",
        text: "Slip has been Received already",
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    fetchError(errorMessage) {
      this.$vs.notify({
        title: "Error!",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    goBack() {
      this.updateBackButton(false);
      this.updateCameraState(false);
      Event.$emit("hideSDPendingDetailsComp");
    },
  },
};
</script>
